document.addEventListener('DOMContentLoaded', () => {
    let animationWrapper = document.querySelector('.trust-tile__animation-wrapper');
    let trustTextArr = animationWrapper.querySelectorAll('.trust-tile__testimonial > span');

    if (trustTextArr.length > 0) {
        document.querySelector('.trust-tile__right').style.height = trustTextArr[0].clientHeight + 'px';
        animationWrapper.style.height = trustTextArr[0].clientHeight + 'px';

        var swiper = new Swiper(".swiper-container", {
            direction: 'vertical',
            loop: true,
            autoplay: {
                delay: 4000,
             },
            slidesPerView: 1,
            speed: 400,
            autoHeight: true
        });
    }
})

